export enum Theme {
  Dark = 'dark',
  Light = 'light'
}

export const defaultTheme = Theme.Dark
